import { useSessionTyped } from './useSession'

export const useIsLoggedIn = () => {
  const session = useSessionTyped()
  return !!session
}
